import { observable, action, runInAction, computed } from "mobx";

import PageStore from "app/PageStore";

import ChatService from "./ChatService";
import { ChatRoomRes, ChatMessageRes } from "./models";
// import { CaseType, Pdf, RfeImage, Block } from "./models";
// import RfeUploadForm from "./commands/RfeUploadForm";
// import RfeEditForm from "./commands/RfeEditForm";

interface Pagination {
  pageSize: number;
  currentPage: number;
  totalSize?: number;
}

export default class ChatStore {
  @observable public loading: boolean = false;

  @observable public dataChatRooms: ChatRoomRes[];
  @observable public dataChatList: ChatMessageRes[];

  @observable public chatRoomPagination: Pagination = {
    pageSize: 15,
    currentPage: 1,
  };
  private chatListPageSize: number = 9999; // TODO: SERVER-SIDE PAGINATION

  private pageStore: PageStore;
  private chatService: ChatService;

  constructor(pageStore: PageStore, chatService: ChatService) {
    this.pageStore = pageStore;
    this.chatService = chatService;
    this.reset();
  }

  @action.bound
  public async listChatRooms() {
    const { openSpinner, openToast, closeSpinner } = this.pageStore;
    openSpinner();
    try {
      const res = await this.chatService.findChatRooms(
        this.chatRoomPagination.pageSize,
        this.chatRoomPagination.currentPage,
      );
      if (!res) {
        throw new Error("Find chatrooms failed.");
      }
      runInAction(() => {
        this.dataChatRooms = res.data;
        this.chatRoomPagination.totalSize = res.count;
      });
    } catch (e) {
      openToast(e.message, { type: "error" });
    } finally {
      closeSpinner();
    }
  }

  @action.bound
  public async listChatList(roomkey: string, currentPage = 1) {
    const { openSpinner, openToast, closeSpinner } = this.pageStore;
    openSpinner();
    try {
      this.loading = true;
      const res = await this.chatService.findChatList(
        roomkey,
        this.chatListPageSize,
        currentPage,
      );
      if (!res) {
        throw new Error("Find chatlist failed.");
      }
      runInAction(() => {
        this.dataChatList = res.sort(
          (chat1: any, chat2: any) => chat1.date - chat2.date,
        );
      });
    } catch (e) {
      openToast(e.message, { type: "error" });
    } finally {
      closeSpinner();
      this.loading = false;
    }
  }

  @action.bound
  public updatePagination(newPage: number) {
    this.chatRoomPagination.currentPage = newPage;
    this.listChatRooms();
  }

  @action.bound
  public reset() {
    this.loading = false;
  }
}
